<template>
  <div class="gm-preview">
    <div
      class="gm-preview__frame campaign-message-details"
      v-if="campaignMethod === 'sms'"
    >
      <VuePerfectScrollbar class="gm-preview__scroll gm-preview__scroll--sms">
        <p>{{ campaignMessage }}</p>
      </VuePerfectScrollbar>
    </div>
    <div
      class="gm-preview__frame campaign-message-details"
      v-if="campaignMethod === 'email'"
    >
      <VuePerfectScrollbar
        class="gm-preview__scroll"
        v-html="campaignMessage"
      >
      </VuePerfectScrollbar>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  middleware: 'auth',

  props: {
    campaignMethod: {
      required: true,
    },
    campaignMessage: {
      required: true,
    },
  },

  components: {
    VuePerfectScrollbar,
  },
};
</script>

<style>
/* Rendered inside the wizard root or a gs-named-modal (both `.gs-app`), so tokens resolve. */
.gm-preview__frame {
  width: 100%;
}

.gm-preview__scroll {
  width: 100%;
  padding: 16px;
  color: var(--gs-foreground);
  font-size: 14px;
  line-height: 1.55;
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-md);
  overflow-y: auto;
}

.gm-preview__scroll--sms {
  height: 208px;
  white-space: pre-wrap;
}

.gm-preview__scroll--sms p {
  margin: 0;
}
</style>
